export enum AppRoutingEnum {
  GEOLOCATION = 'geolocation',
  ALERT_NOTIFICATIONS = 'alert-notifications',
  CROP = 'crop',
  CROP_MANAGEMENT = 'crop-management',
  MULTI_INTERVENTIONS = 'multi-interventions',
  USER_PREFERENCES = 'user-preferences',
  FARM = 'farm',
  FIELD = 'field',
  DASHBOARD = 'dashboard',
  TPA = 'third-party-applicator',
  RECOMMENDATION = 'recommendation',
  SCOUTING = 'scouting',
  INTERVENTION = 'intervention',
  PLANTING = 'planting',
  PRE_CLOSING = 'pre-closing',
  MULTI_INTERVENTION_ENTRY = 'multi-intervention-entry',
  SAMPLE = 'sample',
  LOGOUT = 'logout',
  HISTORY = 'history',
  WORKLIST = 'worklist',
  MANAGE_WORKLIST = 'manage-worklist',
  CSR = 'csr',
  SUPPLIERS = 'suppliers',
  CREATE = 'create',
  EDIT = 'edit',
  BASIN_MANAGEMENT = 'basin-management',
  LEAVE_APPLICATION = 'leave-application',
  PHYTO = 'phytoReports',
}
